import { graphql } from "react-relay";
import { SuggestionCard } from "@components/suggestion-card";

export const fragments = {
  viewer: graphql`
    fragment SuggestionsFeed_viewer on Viewer
    @argumentDefinitions(debugFetchDate: { type: "BigInt" }) {
      user {
        orgs(first: 1000000) {
          edges {
            node {
              ...SuggestionCard_org
              experiments
              feedSuggestionsErrorable(debugFetchDate: $debugFetchDate) {
                __typename
                ... on GraphEntityError {
                  statusCode
                  message
                }
                ... on FeedSuggestionResults {
                  suggestions {
                    id
                    occurredMillis
                    suggestionType
                    ...SuggestionCard_feedSuggestion
                    suggestionPayload {
                      __typename
                      ... on SuggestionResultChromeExtensionTipPayload {
                        tipType
                      }
                      ... on SuggestionResultMissingUserConfigurationPayload {
                        configurationType
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
};

export const query = graphql`
  query SuggestionsFeedQuery($debugFetchDate: BigInt) {
    viewer {
      ...SuggestionsFeed_viewer @arguments(debugFetchDate: $debugFetchDate)
    }
  }
`;
